export enum ApiMethodEnum {
  Get = "Get",
  Post = "Post",
  Put = "Put",
  Delete = "Delete",
}
